// Angular imports
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
import { MatInputModule } from '@angular/material/input'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatSelectModule } from '@angular/material/select'
import { MatButtonModule } from '@angular/material/button'
import { MatAutocompleteModule } from '@angular/material/autocomplete'

// Third-party imports
import { NgbModule } from '@ng-bootstrap/ng-bootstrap'
import { ToastrModule } from 'ngx-toastr'
import { DragDropModule } from '@angular/cdk/drag-drop'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { WjNavModule } from '@grapecity/wijmo.angular2.nav'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'
import { WjChartModule } from '@grapecity/wijmo.angular2.chart'
import { WjGaugeModule } from '@grapecity/wijmo.angular2.gauge'
import { WjChartAnnotationModule } from '@grapecity/wijmo.angular2.chart.annotation'
import { WjGridGrouppanelModule } from '@grapecity/wijmo.angular2.grid.grouppanel'
import { WjBarcodeCommonModule } from '@grapecity/wijmo.angular2.barcode.common'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { LOAD_WASM, NgxScannerQrcodeService } from 'ngx-scanner-qrcode'

//  WebTools Imports
import { AuthenticationService } from './authentication.service'
import { Services } from './services'
import { NgProgressModule } from './progress'
import {
    GridEventsDirective,
    AutoSizeDirective,
    UtilityService,
    ModelDebounceDirective,
    CustomGridEditorDirective,
    RouteGuard,
    WjDropDownExpandDirective,
    DbUpdateButtonDirective,
} from './utility'
import { JsonDateInterceptor } from './json-date-interceptor'
import { GridExportComponent } from './reusable-components/grid-export/grid-export.component'
import { GridColumnGroupComponent } from './reusable-components/grid-column-group/grid-column-group.component'
import { ActionToolbarCount } from './reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from './reusable-components/action-toolbar-search/action-toolbar-search.component'
import { ActionToolbarButtonsComponent } from './reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { GridSelectionCalculationComponent } from './reusable-components/grid-selection-calculation/grid-selection-calculation.component'
import { GridPdfExportComponent } from './reusable-components/grid-pdf-export/grid-pdf-export.component'

// Necessary to solve the problem of losing internet connection
LOAD_WASM().subscribe()

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        NgProgressModule,
        DragDropModule,
        NgbModule,
        WjGridModule,
        WjGridFilterModule,
        WjNavModule,
        WjChartModule,
        WjInputModule,
        WjChartAnnotationModule,
        WjGridGrouppanelModule,
        WjBarcodeCommonModule,
        WjGaugeModule,
        ToastrModule.forRoot(),
        MatInputModule,
        MatFormFieldModule,
        MatSelectModule,
        MatButtonModule,
        FontAwesomeModule,
        GridEventsDirective,
        AutoSizeDirective,
        ModelDebounceDirective,
        CustomGridEditorDirective,
        WjDropDownExpandDirective,
        DbUpdateButtonDirective,
        GridExportComponent,
        GridPdfExportComponent,
        GridColumnGroupComponent,
        ActionToolbarCount,
        ActionToolbarSearchComponent,
        ActionToolbarButtonsComponent,
        GridSelectionCalculationComponent,
    ],
    providers: [
        AuthenticationService,
        RouteGuard,
        Services,
        UtilityService,
        NgxScannerQrcodeService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JsonDateInterceptor,
            multi: true,
        },
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        NgProgressModule,
        DragDropModule,
        NgbModule,
        ToastrModule,
        WjGridModule,
        WjChartModule,
        WjInputModule,
        WjChartAnnotationModule,
        WjGridGrouppanelModule,
        WjBarcodeCommonModule,
        WjGaugeModule,
        GridEventsDirective,
        AutoSizeDirective,
        ModelDebounceDirective,
        CustomGridEditorDirective,
        DbUpdateButtonDirective,
        WjDropDownExpandDirective,
        WjGridFilterModule,
        WjNavModule,
        MatInputModule,
        MatFormFieldModule,
        MatSelectModule,
        MatButtonModule,
        MatAutocompleteModule,
        GridExportComponent,
        GridPdfExportComponent,
        GridColumnGroupComponent,
        FontAwesomeModule,
        ActionToolbarCount,
        ActionToolbarSearchComponent,
        ActionToolbarButtonsComponent,
        GridSelectionCalculationComponent,
    ],
})
export class SharedModule {}
